import { Modal } from "@/components";
import { Grid, Typography, useMediaQuery } from "@mui/material";

function Card({
  icon,
  title,
  counter,
  unit,
  additionalChild = undefined,
  onClick,
  width = "200px",
  sx = {},
}) {
  const md = useMediaQuery("(max-width:450px)");

  return (
    <Modal
      titleVariant="body2"
      icon={icon}
      title={title}
      width={md ? "100%" : width}
      sx={sx}
      onClick={onClick}
    >
      <Grid
        display={"flex"}
        flexDirection={"row"}
        justifyContent={additionalChild ? "space-around" : "center"}
        alignItems={"center"}
        alignContent={"center"}
        sx={{ margin: "10px 0" }}
      >
        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"15px"}
          alignItems={"center"}
          sx={{
            textAlign: "center",

            minHeight: md ? "50px" : "unset",
            height: "100%",
          }}
        >
          <Typography
            variant={
              counter === undefined || counter.toString().length > 5
                ? "body1"
                : "h6"
            }
          >
            {counter}
          </Typography>

          {unit && (
            <Typography variant="caption" color={"var(--emr-text-light)"}>
              {unit}
            </Typography>
          )}
        </Grid>
        {additionalChild && <Typography color={"primary"}>|</Typography>}
        {additionalChild && additionalChild}
      </Grid>
    </Modal>
  );
}

export default Card;
